import React, { useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from '@emotion/styled';
import { GatsbyImage, getImage, withArtDirection } from "gatsby-plugin-image";
import SectionHeadline from '../../../components/SectionHeadline'
import { Timeline } from 'react-twitter-widgets'
import SocialMediaNav from './SocialMediaNav';
import { useLocalization } from 'gatsby-theme-i18n';
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import { useInView } from 'react-intersection-observer';

const LatestNewsSection = (props) => {

  const { t , currentLocaleObj } = useLocalization();
  const [ loaded, setLoaded ] = useState(false);
  const [ currentLang, setCurrentLang ] = useState(currentLocaleObj.code);
  const { ref, inView } = useInView({
    rootMargin: "100px 0px 30px 0px"
  });

  const data = useStaticQuery(graphql`
  query LatestNews {
    background : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_newsSection.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
    background_mobile : file(sourceInstanceName: {eq: "images"}, relativePath: {eq: "layout/bg_newsSection_mobile.jpg"}) {
      childImageSharp {
        gatsbyImageData(
          layout: FULL_WIDTH
          placeholder: NONE
        )
      }
    }
  }
`);

const twitterID = {'ja' : 'FF_XIV_JP','en-US':'FF_XIV_EN','en-GB' : 'FF_XIV_EN','fr':'FF_XIV_FR','de':'FF_XIV_DE'};

useEffect(() =>{
  if(currentLang !== currentLocaleObj.code)
  {
    setLoaded(false);
    setCurrentLang(currentLocaleObj.code);
  }
},[currentLang,currentLocaleObj]);

  return (
    <SectionWrapper>
      <Content>
        <SectionHeadline title={t('home.latest_information.title')} color={'#D00F31'} icon={'Meteor'} />
        <TwitterContainer ref={ref}>
          {(inView || loaded) &&
            <Timeline
              dataSource={{
                sourceType: 'profile',
                screenName: twitterID[currentLocaleObj.code]
              }} 
              onLoad={() => {
                setLoaded(true)
              }}
              renderError={(_err) => <ErrorMsg>Something went wrong. Please try again later.</ErrorMsg>}
              options={{
                width: '100%',
                height: '100%'
              }}
            />
            }
        </TwitterContainer>
        <SocialMediaNav list={[
          {
            link : t('nav.sns.twitter.url'),
            type : 'Twitter',
            alt : t('nav.sns.twitter.label')
          },
          {
            link : t('nav.sns.facebook.url'),
            type :  'Facebook',
            alt : t('nav.sns.facebook.label')
          },
          {
            link : t('nav.sns.line.url'),
            type :  'Line',
            alt : t('nav.sns.line.label')
          },
          {
            link : t('nav.sns.instagram.url'),
            type :  'Instagram',
            alt : t('nav.sns.instagram.label')
          },
          {
            link : t('nav.sns.youtube.url'),
            type :  'Youtube',
            alt : t('nav.sns.youtube.label')
          },
          {
            link : t('nav.sns.twitch.url'),
            type :  'Twitch',
            alt : t('nav.sns.twitch.label')
          }]} />
        <Background><GatsbyImage image={
          withArtDirection(getImage(data.background), [
            {
              media: `(min-width: ${breakpoint.smMin})`,
              image: getImage(data.background),
            },
            {
              media: `(max-width: ${breakpoint.xsMax})`,
              image: getImage(data.background_mobile),
            }
          ])} alt="background" /></Background>
      </Content>
    </SectionWrapper>
  );
};


export default LatestNewsSection;

const ErrorMsg = styled.div`
  text-align:center;
  position:absolute;
  top:50%;
  left:0;
  width:100%;
`

const SectionWrapper = styled.div`
  background:#F7F7FA;
  margin:96px 0;
  @media only screen and (max-width: ${breakpoint.smMax}){
    margin:0;
  }
  
  
`;
const Content = styled.div`
  width:100%;
  max-width:1440px;
  display:flex;
  flex-direction:column;
  justify-content:center;

  margin:0 auto;
  background:#ECECEF;
  position:relative;
  border-radius: 4px;
  overflow:hidden;
  padding:96px 0;

  @media only screen and (max-width: ${breakpoint.smMax}){
    padding:64px 80px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    padding:32px 24px 24px;
  }
`

const Background = styled.div`
  width:720px;
  height:952px;
  position:absolute;
  top:0;
  right:0;
  @media only screen and (max-width: ${breakpoint.xsMax}){
    width:100%;
    height:100%;
    > div{
      height: 100%;
    }
  }
`

const TwitterContainer = styled.div`
  position:relative;
  z-index:2;
  margin:48px auto;
  width:640px;
  height:576px;
  > div,> div > div{
    width:100%;height:100%;
  }
  @media only screen and (max-width: ${breakpoint.smMax}){
    width:100%;
    height:480px;
    margin:36px 0;
  }
  @media only screen and (max-width: ${breakpoint.xsMax}){
    margin-bottom:8px;
    margin-top:16px;
    height:296px;
  }
`
